import { defineMessages } from 'react-intl';

export const footerMessages = defineMessages({
  powered_by_caazam: {
    id: 'messages.powered_by_caazam',
  },
});
